export { default } from './TabPaymentMethods';